import { Icon } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import ScratchClass from '@utils/scratch';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './PaySuccess.less';

export default class PaySuccess extends OfficialPage {
  state = {
    status: 0, // 0: 普通页面 1:有集集乐的情况
    orderId: '', // 订单号
    franchiseeId: '', // 子店id
    wayOfDine: 0, // 1:点餐, 2:预约
    queueNum: 0, // 取餐号
    durationTime: 0,
    appointmentTime: 0,
    collectBenefitData: {}, // 集集乐数据
    starData: [], // 集集乐的星 light:已集样式 dark:未集样式
    isFail: true, //刮刮乐未中奖
    isWinning: true, //刮刮乐中奖
    isComfort: true, //刮刮乐安慰奖
    isWhole: true, //刮奖区域是否显示
    scratchId: '', //活动号
    isShowteam: false,
    winingTitle: '',
    isScroll: true, //刮刮乐当在 canvas 中移动时且有绑定手势事件时禁止屏幕滚动以及下拉刷新，
    ifWxCoupon: false,
    timestamp: '',
    signature: '',
    ifGetComfort: false
  }

  constructor(props) {
    super(props);
    document.title = '支付成功';
  }

  componentDidMount(options = getCurrentPageQueryParams()) {
    let that = this
    that.setData({
      orderId: options.detail,
      franchiseeId: options.franchisee || ''
    })
    that.getOrderDetail()
    if (options.collectBenefit == 1) {
      that.getCollectBenefitData(options.detail)
      that.setData({
        status: 1
      })
    }
    that.getGoldenData(options.detail)
    let systemInfo = app.globalData.systemInfo || {}
    let width = (558 * systemInfo.windowWidth) / 750
    let height = (258 * systemInfo.windowWidth) / 750
    that.scratch = new ScratchClass(that, {
      canvasWidth: width,
      canvasHeight: height,
      imageResource:
        app.getSiteBaseUrl() +
        '/index.php?r=Download/DownloadResourceFromUrl&url=https://chn.jisuapp.cn/zhichi_frontend/static/webapp/images/scratchMovie.png',
      maskColor: 'red',
      r: 18,
      callback: () => {
        that.setData({
          hideCanvas: true
        })
        if (that.data.ifWxCoupon) {
          setTimeout(function() {
            that.toAddCard()
          }, 500)
        }
      },
      imgLoadCallback: () => {
        setTimeout(function() {
          that.setData({
            isShowteam: true
          })
        }, 10)
      }
    })
  }

  getOrderDetail = () => {
    var that = this
    app.getOrderDetail({
      data: {
        order_id: that.data.orderId,
        sub_shop_app_id: that.data.franchiseeId
      },
      success: function (res) {
        var tostore_data = res.data[0].form_data.tostore_data
        that.setData({
          wayOfDine: tostore_data.tostore_order_type,
          queueNum: tostore_data.formatted_queue_num,
          appointmentTime: tostore_data.tostore_appointment_time.substr(11, 5),
          durationTime: tostore_data.duration_time
        })
      }
    })
  }
  getCollectBenefitData = id => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppMarketing/CollectmeSendCoupon',
      data: {
        order_id: id,
        sub_app_id: that.data.franchiseeId
      },
      hideLoading: true,
      success: function (res) {
        let starData = []
        for (var i = 0; i < res.data.star_num; i++) {
          starData.push('light')
        }
        for (var i = 0; i < res.data.collect_num - res.data.star_num; i++) {
          starData.push('dark')
        }
        that.setData({
          collectBenefitData: res.data,
          starData: starData
        })
      }
    })
  }
  touchStart = e => {
    if (!this.isStart) return
    let pos = this.drawRect(e.touches[0].x, e.touches[0].y)
    this.ctx.clearRect(pos[0], pos[1], pos[2], pos[2])
    this.ctx.draw(true)
  }
  touchMove = e => {
    if (!this.isStart) return
    let pos = this.drawRect(e.touches[0].x, e.touches[0].y)
    this.ctx.clearRect(pos[0], pos[1], pos[2], pos[2])
    this.ctx.draw(true)
  }
  touchEnd = e => {
    if (!this.isStart) return
    let { canvasWidth, canvasHeight, minX, minY, maxX, maxY } = this
    if (maxX - minX > 0.5 * canvasWidth && maxY - minY > 0.5 * canvasHeight) {
      this.ctx.draw()
      this.endCallBack && this.endCallBack()
      this.isStart = false
      this.page.setData({
        isScroll: true
      })
    }
  }
  getGoldenData = id => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getTimeAfterConsume',
      method: 'post',
      data: {
        order_id: id,
        sub_app_id: that.data.franchiseeId
      },
      success: function (data) {
        if (data.data) {
          that.setData({
            isWhole: false,
            scratchId: data.data
          })
        } else {
          that.setData({
            isWhole: true
          })
        }
        if (data.integral) {
          //支付获取积分
          that.setData({
            rewardPointObj: {
              showModal: true,
              count: data.integral,
              callback: ''
            }
          })
        }
      }
    })
  }
  showAreaClick = () => {
    let that = this
    that.setData({
      isShowteam: false
    })
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/lottery',
      hideLoading: true,
      data: {
        activity_id: that.data.scratchId,
        sub_app_id: that.data.franchiseeId
      },
      success: function (res) {
        let data = res.data
        that.scratch.start()
        if (data.title == '谢谢参与') {
          that.setData({
            isFail: false
          })
        } else {
          let params = {
            ifWxCoupon: data.card_id || false,
            timestamp: data.timestamp || '',
            signature: data.signature || ''
          }
          if (data.is_comfort) {
            params['isComfort'] = false
          } else {
            params['isWinning'] = false
            params['winingTitle'] = data.title
          }
          that.setData(params)
        }
      }
    })
  }
  goToHomepage = () => {
    var homepageRouter = app.getHomepageRouter()
    app.reLaunch({
      url: '/pages/' + homepageRouter + '/' + homepageRouter
    })
  }
  goToOrderDetail = () => {
    let franchisee = this.data.franchiseeId || ''
    app.turnToPage(
      '/orderMeal/pages/tostoreOrderDetail/tostoreOrderDetail?detail=' +
      this.data.orderId +
      '&franchisee=' +
      franchisee,
      1
    )
  }
  toAddCard = () => {
    let _data = this.data,
      wxcouponId = _data.ifWxCoupon,
      _this = this
    app.addCard({
      cardList: [
        {
          cardId: wxcouponId,
          cardExt:
            '{"nonce_str":"' +
            _data.timestamp +
            '","timestamp":"' +
            _data.timestamp +
            '", "signature":"' +
            _data.signature +
            '"}'
        }
      ],
      success: function (res) {
        _this.setData({
          ifWxCoupon: false,
          ifGetComfort: true
        })
        app.sendRequest({
          url: '/index.php?r=appLotteryActivity/recvWeChatCoupon',
          data: {
            card_id: res.cardList[0].cardId,
            sub_app_id: _data.franchisee,
            activity_id: _data.scratchId
          },
          success: function (res) {
            app.showModal({
              title: '提示',
              content: '领取卡券成功',
              showCancel: false
            })
          }
        })
      }
    })
  }

  render() {
    const {
      rewardPointObj,
      shareGiftsObj,
      collectGiftsObj,
      collectGetObj,
      showGetUserInfo,
      queueNum,
      durationTime,
      wayOfDine,
      appointmentTime,
      status,
      collectBenefitData,
      starData,
      isWhole,
      isFail,
      isWinning,
      winingTitle,
      isComfort,
      ifGetComfort,
      ifWxCoupon,
      hideCanvas,
      scratch,
      isScroll,
      isShowteam
    } = this.state

    return (
      <div className="official-page pay-success">
        <TopNav title="支付成功"/>
        <React.Fragment>
          <div>
            {status == 0 && (
              <div className="normal-area">
                <div>
                  <Icon type="check-circle" color="#09BB07" size="lg"></Icon>
                </div>
                <div className="paySuccess-tip">支付成功</div>
                <div className="paySuccess-detail">
                  <div>
                    您的排队号为:
                    <span className="paySuccess-queue-num">{queueNum}</span>
                  </div>
                  {wayOfDine == 1 && (
                    <React.Fragment>
                      <div style={convertLineStyleData('margin-top:15px;')}>
                        {'大约' + durationTime + '分钟后到店消费'}
                      </div>
                    </React.Fragment>
                  )}
                  {wayOfDine == 2 && (
                    <React.Fragment>
                      <div style={convertLineStyleData('margin-top:15px;')}>
                        {'请在预约到店时间 ' + appointmentTime + ' 到店消费'}
                      </div>
                    </React.Fragment>
                  )}
                </div>
              </div>
            )}
            {status == 1 && (
              <div className="has-collect-benefit">
                <div className="pay-success-item">
                  <Icon className="icon" type="check-circle" color="#09BB07" size="lg"></Icon>
                  <div className="text">支付成功</div>
                </div>
                <div className="to-store-area">
                  <div className="info-item">
                    <div className="item-name">排队号：</div>
                    <div className="item-content queue-num">{queueNum}</div>
                  </div>
                  <div className="info-item">
                    <div className="item-name">到店时间：</div>
                    {wayOfDine == 1 && (
                      <div className="item-content">
                        {'大约' + durationTime + '分钟后到店消费'}
                      </div>
                    )}
                    {wayOfDine == 2 && (
                      <div className="item-content">
                        {'请在预约到店时间 ' + appointmentTime + ' 到店消费'}
                      </div>
                    )}
                  </div>
                  <div className="info-item">
                    <div className="item-name">到店方式：</div>
                    {wayOfDine == 1 && (
                      <div className="item-content">立即到店</div>
                    )}
                    {wayOfDine == 2 && (
                      <div className="item-content">预约到店</div>
                    )}
                  </div>
                </div>
                <div className="collect-benefit-area">
                  <div className="collect-item">
                    <div className="star-num">
                      {'集集乐个数: ' + collectBenefitData.star_num}
                    </div>
                    <div className="star-list">
                      {starData.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            {item == 'light' ? (
                              <img
                                className="star-item"
                                src={collectBenefitData.light_img}
                              />
                            ) : (
                                item == 'dark' && (
                                  <img
                                    className="star-item"
                                    src={collectBenefitData.dark_img}
                                  />
                                )
                              )}
                          </React.Fragment>
                        )
                      })}
                    </div>
                    {collectBenefitData.star_num ==
                      collectBenefitData.collect_num && (
                        <div className="star-full">
                          <div className="star-full-text">满</div>
                        </div>
                      )}
                  </div>
                  <div className="tip-item">
                    {collectBenefitData.star_num ==
                      collectBenefitData.collect_num ? (
                        <div>{'获得一张' + collectBenefitData.coupon_title}</div>
                      ) : (
                        collectBenefitData.star_num !=
                        collectBenefitData.collect_num && (
                          <div>
                            {'消费' +
                              (collectBenefitData.play_type == 0
                                ? '每满'
                                : '超过') +
                              collectBenefitData.value +
                              '元，累计一颗星，集满可获得' +
                              collectBenefitData.coupon_title +
                              '一张'}
                          </div>
                        )
                      )}
                  </div>
                </div>
              </div>
            )}
            {/*  刮刮乐  */}
            <div className="scratchWhole" hidden={isWhole}>
              <div className="scratchArea">
                <div className="scratchFail" hidden={isFail}>
                  <img src="http://cdn.jisuapp.cn/static/webapp/images/scratchFail.png" />
                  <div className="failTitle">
                    <div className="failShare" onClick={this.shareClickEvent}>分享</div>
                    <div className="failText">很遗憾没有中奖哦</div>
                  </div>
                </div>
                {/*  中奖  */}
                <div className="scratchWinning" hidden={isWinning}>
                  <img src="http://cdn.jisuapp.cn/static/webapp/images/scratchPrize.png" />
                  <div className="winningTitle">
                    <div className="winningShare" onClick={this.shareClickEvent}>分享</div>
                    <div className="winningText">恭喜你获得了</div>
                    <div className="winningText winningValue">
                      {winingTitle}
                    </div>
                  </div>
                </div>
                {/*  安慰奖  */}
                <div className="scratchComfort" hidden={isComfort}>
                  <img src="http://cdn.jisuapp.cn/static/webapp/images/scratchComfort.png" />
                  <div className="comfortTitle">
                    <div className="comfortShare" onClick={this.shareClickEvent}>分享</div>
                    {ifGetComfort ? (
                      <div className="comfortText">
                        已领取，在微信卡包中查看哦~
                      </div>
                    ) : (
                        <div className="comfortText" className="comfortText">
                          又没中奖，送你一个小礼品
                      </div>
                      )}
                    {!ifWxCoupon && !ifGetComfort && (
                      <div className="comfortText">
                        >在优惠券卡包进行查收哦~
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className="scratch_wp"
                  hidden={hideCanvas}
                  style={convertLineStyleData(
                    'width: ' +
                    (scratch && scratch.width) +
                    'px; height: ' +
                    (scratch && scratch.height) +
                    'px;'
                  )}
                >
                  <canvas
                    className="scratch-canvas"
                    width={scratch && scratch.width}
                    height={scratch && scratch.height}
                    id="scratch-canvas"
                    onTouchStart={this.touchStart}
                    onTouchMove={this.touchMove}
                    onTouchEnd={this.touchEnd}
                  ></canvas>
                  {isShowteam && (
                    <div className="showArea">
                      <div className="showTitle">赢取优惠大奖</div>
                      <div className="showBtn" onClick={this.showAreaClick}>
                        点我刮奖
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="btn-area">
              <div className="finish-btn" onClick={this.goToHomepage}>
                完成
              </div>
              <div className="check-order-btn" onClick={this.goToOrderDetail}>
                查看订单
              </div>
            </div>
          </div>
        </React.Fragment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/pay-success/PaySuccess.jsx